import { render, staticRenderFns } from "./UsTreatmentHistory.vue?vue&type=template&id=5d31de6b&scoped=true&"
import script from "./UsTreatmentHistory.vue?vue&type=script&lang=js&"
export * from "./UsTreatmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./UsTreatmentHistory.vue?vue&type=style&index=0&id=5d31de6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d31de6b",
  null
  
)

export default component.exports